export class Noticia {

    id: number;
    titulo: string = '';
    descricaoSimples: string = '';
    descricao: string = '';
    data: Date = new Date();
    slug: string = '';
    tag: string = '';
    tempoLeitura: string = '';
    imagemPequena: string = '';
    imagemGrande: string = '';
    situacao: string = 'A';
    [x: string]: any;

    constructor(obj?) {
        Object.assign(this);
    }
}